module.exports = __webpack_public_path__ + "assets/img/index3.491c4f53.png";